import React, { createContext, useContext, useState } from 'react';

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [progress, setProgress] = useState(0);

    return (
        <LoaderContext.Provider value={{ loading, setLoading, progress, setProgress }}>
            {children}
        </LoaderContext.Provider>
    );
};

export const useLoader = () => useContext(LoaderContext);
